import { Row, Col, Breadcrumb } from "react-bootstrap";

interface IBreadCrumProps {
  regno: string;
}

const BreadCrumbs = ({ regno }: IBreadCrumProps) => {
  return (
    <Row>
      <Col xs="12">
        <Breadcrumb className="leap">
          <Breadcrumb.Item href="/abstractions">Abstractions</Breadcrumb.Item>
          <Breadcrumb.Item>{regno}</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default BreadCrumbs;
